export default "/images/notifications.png?24c1e7b3866d900bf154ecb9b9ce21b6";